module.exports = __webpack_public_path__ + "media/images/phone/header-bookshelf@2x-0fd5afba415c74664f8518b65db7fd6d.png";